import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor() { }

  checkMenuPermission(menuSlug: string) {
    let localPermissionData = this.getLocalStore('aPermission')?.main;
    let isOnBehalf = this.getLocalStore('isOnBehalf');
    
    if(!!isOnBehalf && isOnBehalf) {
      let onBehalfUserData = this.getLocalStore('onBehalfUserData');
      localPermissionData = onBehalfUserData?.onBehalfData;

      if(['messages'].indexOf(menuSlug) > -1) return false;
    }

    if(!!localPermissionData 
      && (
        (localPermissionData.screens.indexOf(menuSlug) > -1)
        || (menuSlug === 'on-behalf-list' && !!localPermissionData?.allow_down && localPermissionData?.allow_down !== 'No')
      )
    ) {
      return true;
    }

    return false;
  }

  checkSectionPermission(sectionName: string, isForExport: boolean = false) {
    let localPermissionData = this.getLocalStore('aPermission')?.main;
    let mainPermissionData = { ...localPermissionData };
    let isOnBehalf = this.getLocalStore('isOnBehalf');

    var onBehalfPermissionData: any = {};
    if (!!isOnBehalf && isOnBehalf) {
      let onBehalfUserData = this.getLocalStore('onBehalfUserData');
      onBehalfPermissionData = { ...onBehalfUserData?.onBehalfData };
      // localPermissionData = onBehalfUserData?.onBehalfData;
    }

    // First Check in Main
    if (!isOnBehalf &&
      !!mainPermissionData[sectionName] && !!mainPermissionData[sectionName][0] && (['Y', 'E'].indexOf(mainPermissionData[sectionName][0]) > -1)
    ) {
      if(isForExport && mainPermissionData[sectionName][0] !== 'E') return false;
      return true;
    }
    // Then Check in Sub
    if (!!isOnBehalf && isOnBehalf &&
      !!mainPermissionData[sectionName] &&
      !!mainPermissionData[sectionName][1] &&
      (
        (mainPermissionData[sectionName][1] === 'Y') ||
        (mainPermissionData[sectionName][1] === 'R' && !!onBehalfPermissionData[sectionName] && 
        ['Y', 'E'].indexOf(onBehalfPermissionData[sectionName][0]) > -1)
      )
    ) {
      if(isForExport && onBehalfPermissionData[sectionName][0] !== 'E') return false;
      return true;
    }
    return false;
  }

  getLocalStore(key: string) {
    let data: any='';
    if (!!key && localStorage.getItem(key) !== undefined && localStorage.getItem(key) !== null) {
      let localData: any = localStorage.getItem(key);
      if(!!localData && localData !== 'undefined') {
        data = JSON.parse(localData)
      }
    }
    return data;
  }

}